define("shared/components/shared/credentials/upgrade-button", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component", "ember-concurrency", "later/errors/credentials"], function (_exports, _component, _templateFactory, _object, _service, _component2, _emberConcurrency, _credentials) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"later/errors/credentials"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Ui::Button
    @additional={{@additional}}
    @promise={{if @action (action "doAction" @action) (task this.connectBusiness)}}
    @runningText={{t "shared_phrases.please_wait"}}
    @size="regular"
    @text={{this.text}}
    @variant="outline"
    class={{@buttonClass}}
    data-social-profile-refresh-id="business-upgrade-button"
    title={{if @socialProfile.errorText @socialProfile.errorText this.text}}
    ...attributes
  />
  */
  {
    "id": "dObQd6Hw",
    "block": "[[[8,[39,0],[[16,0,[30,1]],[24,\"data-social-profile-refresh-id\",\"business-upgrade-button\"],[16,\"title\",[52,[30,2,[\"errorText\"]],[30,2,[\"errorText\"]],[30,0,[\"text\"]]]],[17,3]],[[\"@additional\",\"@promise\",\"@runningText\",\"@size\",\"@text\",\"@variant\"],[[30,4],[52,[30,5],[28,[37,2],[[30,0],\"doAction\",[30,5]],null],[28,[37,3],[[30,0,[\"connectBusiness\"]]],null]],[28,[37,4],[\"shared_phrases.please_wait\"],null],\"regular\",[30,0,[\"text\"]],\"outline\"]],null]],[\"@buttonClass\",\"@socialProfile\",\"&attrs\",\"@additional\",\"@action\"],false,[\"shared/ui/button\",\"if\",\"action\",\"task\",\"t\"]]",
    "moduleName": "shared/components/shared/credentials/upgrade-button.hbs",
    "isStrictMode": false
  });

  let UpgradeButtonComponent = (_dec = (0, _service.inject)('social/instagram-business'), (_class = class UpgradeButtonComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "credentialStatus", _descriptor2, this);

      _initializerDefineProperty(this, "errors", _descriptor3, this);

      _initializerDefineProperty(this, "instagram", _descriptor4, this);

      _initializerDefineProperty(this, "instagramBusiness", _descriptor5, this);

      _initializerDefineProperty(this, "intl", _descriptor6, this);

      _initializerDefineProperty(this, "router", _descriptor7, this);

      _initializerDefineProperty(this, "segmentEvents", _descriptor8, this);

      _defineProperty(this, "onSuccess", null);

      _defineProperty(this, "page", null);
    }

    get text() {
      const fallbackText = this.intl.t('shared_phrases.missing_user_token.button');
      return this.args.buttonText ? this.args.buttonText : fallbackText;
    }

    doAction() {
      let taskName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (taskName === 'getConnectedPages') {
        return this.getConnectedPages.perform();
      } else if (taskName === 'refreshBusiness') {
        return this.refreshBusiness.perform();
      }

      return undefined;
    }

    *getConnectedPages() {
      const {
        connectedPages,
        pages,
        authResponse
      } = yield this.instagramBusiness.getConnectedPages.perform(this.args.socialProfile);
      const facebookUser = yield this.instagramBusiness.fetchFacebookSelf();

      if (typeof this.onSuccess === 'function') {
        this.onSuccess({
          connectedPages,
          pages,
          authResponse,
          facebookUser
        });
      }
    }

    *refreshBusiness() {
      yield this.instagramBusiness.refreshBusiness.perform(this.args.socialProfile);

      if (typeof this.onSuccess === 'function') {
        this.onSuccess();
      }
    }

    *connectBusiness() {
      const page = this.args.path === 'account.groups.group' ? 'account-settings' : this.router.currentRouteName;

      try {
        this.segmentEvents.trackAttemptedBusinessConnect(this.args.socialProfile, page);
        yield this.instagramBusiness.refreshBusinessAccountEndpoint(this.args.socialProfile, this.page);
        this.instagram.clearError();

        if (typeof this.onSuccess === 'function') {
          this.onSuccess(this.args.socialProfile);
          this.credentialStatus.checkBrokenProfiles();
        }

        if (this.args.path) {
          this.router.transitionTo(`${this.args.path}`, this.args.socialProfile.urlName);
        }
      } catch (error) {
        if (error instanceof _credentials.CredentialsNotFoundError) {
          error.resolve.call(this, this.args.socialProfile);
        } else {
          this.errors.log(error);
        }
      }
    }

    *refreshBasicDisplay() {
      try {
        yield this.instagram.loginInstagram(this.args.socialProfile, true);
      } catch (error) {
        this.errors.log(error);
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "credentialStatus", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "instagram", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "instagramBusiness", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "segmentEvents", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "doAction", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "doAction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getConnectedPages", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "getConnectedPages"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "refreshBusiness", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "refreshBusiness"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "connectBusiness", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "connectBusiness"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "refreshBasicDisplay", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "refreshBasicDisplay"), _class.prototype)), _class));
  _exports.default = UpgradeButtonComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, UpgradeButtonComponent);
});